import { useEffect, useCallback } from "react";
// nnnnew


const useRecaptchaV3 = (siteKey) => {
  useEffect(() => {
    if (!siteKey) {
      console.error("RECAPTCHA site key missing");
      return;
    }
    const scriptId = "recaptcha-v3-script";
    const existingScript = document.getElementById(scriptId);
    if (existingScript) return;

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      //    console.log("  343ddddreCAPTCHA v3 script loaded");
    };

    script.onerror = () => {
      console.error("Failed to load reCAPTCHA v3 script");
    };

    document.head.appendChild(script);
  }, [siteKey]);

  const executeRecaptcha = useCallback(
    (action = "submit") => {
      return new Promise((resolve) => {
        if (!siteKey) {
          console.warn("No siteKey provided to reCAPTCHA");
          return resolve(null);
        }

        if (!window.grecaptcha) {
          console.warn("grecaptcha not available yet");
          return resolve(null);
        }

        try {
          window.grecaptcha.ready(() => {
            window.grecaptcha
              .execute(siteKey, { action })
              .then((token) => {
                // console.log("reCAPTCHA token:", token);
                resolve(token);
              })
              .catch((err) => {
                console.error("Error executing reCAPTCHA:", err);
                resolve(null);
              });
          });
        } catch (err) {
          console.error("Exception in executeRecaptcha:", err);
          resolve(null);
        }
      });
    },
    [siteKey]
  );

  return executeRecaptcha;
};

export default useRecaptchaV3;
// new
// NITISH
// neww
